<template>
	<v-dialog v-model="dialog" width="700">
		<custom-dialog>
			<template v-slot:title>
				{{ tsg('selectCamera') }}
				<button id="dialog_exit">
					<img src="@/assets/images/popup_close.png" id="btn_img" @click="dialog = false">
				</button>
			</template>
			<template v-slot:body>
				<v-row class="ma-0 pa-0" justify="center">
					<v-col class="ma-0 pa-0" cols="11" align="left">
						<!-- 카메라그룹 내 카메라 중 하나를 선택 (분할화면 슬롯 배치용).
							 썸네일은 store-group camera-list 와 동일 스펙:
							 webrtc.playback.ready → item.thumbnail(S3), 그 외 → awsGetThumbnail(KVS base64) -->
						<v-row class="ma-0 pa-0" v-if="cameraList.length > 0" style="max-height:60vh;overflow-y:auto;">
							<v-col class="ma-0 pa-2" cols="4" v-for="(item, index) in cameraList" :key="index">
								<div class="cgs_thumb" style="cursor:pointer;" @click="selectCamera(item)">
									<div v-if="item.offline" class="cgs_state_box">{{ t('offline') }}</div>
									<img v-else-if="item.thumbnailSrc && !item.imageError" :src="item.thumbnailSrc" class="cgs_img"
										@error="onThumbError(index)" />
									<div v-else-if="item.imageError" class="cgs_state_box"></div>
									<v-skeleton-loader v-else type="image" dark class="cgs_skeleton" :boilerplate="false"
										elevation="0"></v-skeleton-loader>
									<div class="cgs_name ellipsis">{{ item.cameraName }}</div>
								</div>
							</v-col>
						</v-row>
						<v-col class="ma-0 pa-10" cols="12" align="center" id="cgs_nodata" v-else>
							{{ t('noData') }}
						</v-col>
					</v-col>
				</v-row>
			</template>
		</custom-dialog>
	</v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean,
		cameras: { type: Array, default: () => [] },
	},
	components: {
		CustomDialog
	},
	mixins: [mixin.common],
	data: () => ({
		dialog: false,
		cameraList: [],
	}),
	watch: {
		dialogVisible: function (item) {
			this.dialog = item;
			if (item) this.buildCameraList(); // 열릴 때 목록 구성 + 썸네일 로드
		},
		dialog: function (item) {
			this.$emit('visible', item);
		},
	},
	methods: {
		tsg(t) {
			return this.$t("lang.group." + t);
		},
		buildCameraList() {
			this.cameraList = (this.cameras || []).map((c) => ({
				...c, thumbnailSrc: null, offline: false, imageError: false
			}));
			this.cameraList.forEach((item, index) => this.loadThumbnail(item, index));
		},
		// store-group camera-list Index.vue 와 동일한 썸네일 취득 스펙
		async loadThumbnail(item, index) {
			if (item.webrtc && item.webrtc.playback && item.webrtc.playback.ready) {
				// webrtc 준비 카메라: S3 썸네일 사용
				this.$set(this.cameraList[index], 'thumbnailSrc', item.thumbnail);
			} else {
				// 그 외: KVS 이미지(base64)
				try {
					const imgList = await this.networkController.awsGetThumbnail(item.streamName);
					this.$set(this.cameraList[index], 'thumbnailSrc', 'data:image/png;base64,' + imgList.ImageContent);
				} catch (e) {
					this.$set(this.cameraList[index], 'offline', true);
				}
			}
		},
		onThumbError(index) {
			this.$set(this.cameraList[index], 'imageError', true);
		},
		selectCamera(item) {
			// 해석된 썸네일(thumbnailSrc)을 포함해 전달 → 슬롯 미리보기에서 그대로 사용
			this.$emit('selectedCamera', item);
			this.dialog = false;
		},
	}
}
</script>

<style lang="scss" scoped>
.cgs_thumb {
	position: relative;
	width: 100%;
	height: 7rem;
	background-color: #222222;
}
.cgs_img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.cgs_skeleton {
	width: 100%;
	height: 100%;
}
.cgs_state_box {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	background: grey;
}
.cgs_name {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 2px 8px;
	background-color: rgba(0, 0, 0, 0.75);
	color: #BEBEBE;
	font-size: 0.75rem;
	text-align: left;
	z-index: 1;
}
.ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
::v-deep .cgs_skeleton .v-skeleton-loader__image {
	height: 7rem;
}
</style>
